// src/utils/actionType.ts
export const createActionType = (base: string) => ({
	START: `${base}_START`,
	DONE: `${base}_DONE`,
	FAILED: `${base}_FAILED`
} as const)

export type ActionTypeGroup = ReturnType<typeof createActionType>
